import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt } from '../../../../common/helper'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const ConfirmModal = ({ updateModal }) => {
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        focusElemnt('okBtn')
    }, [])
    return (
        <Modal
            headTxt={tr('gsConfirm', 'Confirm')}
            width={'35%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Box sx={{ padding: '10px 15px' }}>
                <Typography variant='h6' sx={{ fontWeight: '500', color: "#444", fontSize: '16px', paddingTop: '5px', paddingBottom: '10px' }}>
                    {tr('gsChgUpdBranch', 'Charges Updated for Selected Branch !!!')}
                </Typography>

                <Box className="disabled-wrapper" sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant="contained" id='okBtn' style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="btn btn-primary"
                        onClick={() => {
                            updateModal(false, mdt.pickupAndDropOffConfModal)
                            focusElemnt('Select_Charge')
                        }}
                    >
                        {tr('gsOk', 'Ok')}
                    </Button>
                </Box>
            </Box>

        </Modal>
    )
}

export default ConfirmModal
